<template>
    <div class="flex lg:mt-5 lg:px-3 w-full" v-if="user">
        <base-dropdown width="w-full">
            <template #trigger>
                <div
                    class="group w-full h-16 lg:h-full bg-gray-700 rounded-none lg:rounded-md p-2 hover:bg-gray-300 focus:outline-none focus:bg-gray-100 transition cursor-pointer"
                    id="options-menu" aria-haspopup="true" aria-expanded="true">
                    <div class="flex w-full justify-between items-center h-full">
                        <div class="flex items-center justify-between space-x-2 text-left">
                            <div
                                class="flex justify-center flex-wrap content-center h-10 w-10 rounded-full flex-shrink-0 text-gray-300 bg-gray-800">
                                <icon name="user" class="h-5 w-5"/>
                            </div>
                            <div class="flex-shrink">
                                <h2 class="text-gray-300 group-hover:text-gray-700 group-focus:text-gray-700 text-sm leading-5 font-medium lg:w-36 truncate">
                                    {{ user.name }}</h2>
                                <p class="text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 text-sm leading-5 truncate"
                                   v-if="user.roles[0]">{{ user.roles[0].label }}</p>
<!--                                <div class="text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 text-sm leading-5 truncate space-x-1 w-full"-->
<!--                                   v-if="user.stores.length > 0">-->
<!--                                    <span v-for="store in user.stores">#{{ store.number }}</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <icon name="switch-vertical-alt"
                              class="h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 flex-shrink-0"
                              viewBox="0 0 20 20" fill="currentColor" stroke="0"/>
                    </div>
                </div>
            </template>
            <template #content>
                <base-dropdown-link :href="route('profile.show')">
                    {{ $t('general.profile') }}
                </base-dropdown-link>
                <base-dropdown-link @clicked="logout">
                    {{ $t('auth.logout') }}
                </base-dropdown-link>
            </template>
        </base-dropdown>
    </div>
</template>

<script>
export default {
    name: 'NavigationUserBar',

    methods: {
        logout() {
            axios.post(route('logout')).then(response => {
                window.location = '/';
            });
        },
    },

    computed: {
        user() {
            return auth.user;
        },
    },
};
</script>
